enum RbacRole {
  Admin = "admin",
  Member = "member",
}

export interface DeploymentUser {
  id: number;
  name: string;
  email: string;
  login: string;
  role: RbacRole;
  since: string;
  authentication: string;
}

export interface DeploymentUsers {
  users: DeploymentUser[];
}
